import type { Theme } from '../types';
import type { Components } from '@mui/material/styles';

export const MuiFormControlLabel = {
  defaultProps: { slotProps: { typography: { variant: 'subtitle2' } } },
  styleOverrides: { root: { gap: '8px', margin: 0 } },
} satisfies Components<Theme>['MuiFormControlLabel'];
